/* Samtalia — kun den bevægelse designet faktisk har brug for.
   Temaets egen JS (kurv, søgning, menu, variantvælger) rører vi ikke.
   Skrevet i vanilla ES5-agtig stil uden byggetrin, så filen kan lægges
   direkte i assets/ og redigeres i temaeditoren. */
(function () {
  "use strict";

  var rod = document.documentElement;
  rod.classList.add("sam-js");

  var roligBevaegelse = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Scroll-afsløring + samtalelinjen der tegner sig selv ----
     Samtalelinjen er clip-path'et væk, indtil den skal tegnes. En clippet
     node har intet snitfelt, så IntersectionObserver ville aldrig udløse den
     — derfor holder vi øje med dens sektion i stedet for linjen selv. */
  function saetIGang(rodElement) {
    var emner = Array.prototype.slice.call(
      (rodElement || document).querySelectorAll(".afsloer, .linje--tegn")
    ).filter(function (el) {
      return !el.dataset.samKlar;
    });
    if (!emner.length) return;
    emner.forEach(function (el) {
      el.dataset.samKlar = "1";
    });

    if (!("IntersectionObserver" in window) || roligBevaegelse) {
      emner.forEach(function (el) {
        el.classList.add("er-synlig");
      });
      return;
    }

    var venter = new Map();
    var obs = new IntersectionObserver(
      function (poster) {
        poster.forEach(function (post) {
          if (!post.isIntersecting) return;
          (venter.get(post.target) || []).forEach(function (el) {
            el.classList.add("er-synlig");
          });
          venter.delete(post.target);
          obs.unobserve(post.target);
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.02 }
    );

    emner.forEach(function (el) {
      var vagtpost = el.classList.contains("linje--tegn")
        ? el.closest(".samtalia") || el.parentElement || el
        : el;
      if (venter.has(vagtpost)) {
        venter.get(vagtpost).push(el);
      } else {
        venter.set(vagtpost, [el]);
        obs.observe(vagtpost);
      }
    });
  }

  saetIGang(document);

  /* ---- Klæbrig header: en streg dukker op, når man scroller ----
     Vi sætter også --header-height, som temaets egne komponenter
     (fx den klæbrige køb-knap) regner med. Horizons inline-script i
     theme.liquid finder kun sin egen <header-component> og springer
     fra, når headeren er vores. */
  function headerIGang() {
    var header = document.querySelector(".sam-header");
    if (!header || header.dataset.samKlar) return;
    header.dataset.samKlar = "1";

    var opdater = function () {
      header.classList.toggle("er-klaebet", window.scrollY > 8);
    };
    opdater();
    window.addEventListener("scroll", opdater, { passive: true });

    var topbaand = document.querySelector(".sam-topbaand");

    var maalHoejde = function () {
      document.body.style.setProperty("--header-height", header.offsetHeight + "px");
      var gruppe = document.getElementById("header-group");
      if (gruppe) {
        document.body.style.setProperty("--header-group-height", gruppe.offsetHeight + "px");
      }
      /* Hele headergruppen klæber, for en sticky node kan kun bevæge sig
         inden for sin forælder. Topbåndet skal alligevel ud af syne, så
         gruppen klæber et topbånd for højt oppe. */
      document.documentElement.style.setProperty(
        "--sam-topbaand-h",
        (topbaand ? topbaand.offsetHeight : 0) + "px"
      );
    };
    maalHoejde();
    window.addEventListener("resize", maalHoejde, { passive: true });
    if ("ResizeObserver" in window) {
      var iagttager = new ResizeObserver(maalHoejde);
      iagttager.observe(header);
      if (topbaand) iagttager.observe(topbaand);
    }
  }

  /* ---- Mobilmenu ---- */
  function mobilmenuIGang() {
    var menu = document.querySelector(".sam-mobilmenu");
    if (!menu || menu.dataset.samKlar) return;
    menu.dataset.samKlar = "1";

    var aabn = document.querySelector("[data-sam-menu-aabn]");
    var luk = menu.querySelector("[data-sam-menu-luk]");

    var saet = function (aaben) {
      menu.dataset.aaben = aaben ? "true" : "false";
      if (aabn) aabn.setAttribute("aria-expanded", aaben ? "true" : "false");
      document.body.style.overflow = aaben ? "hidden" : "";
      if (aaben) {
        var f = menu.querySelector("a, button");
        if (f) f.focus();
      } else if (aabn) {
        aabn.focus();
      }
    };

    if (aabn) {
      aabn.addEventListener("click", function () {
        saet(menu.dataset.aaben !== "true");
      });
    }
    if (luk) luk.addEventListener("click", function () { saet(false); });
    menu.addEventListener("click", function (e) {
      if (e.target.closest("a")) saet(false);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && menu.dataset.aaben === "true") saet(false);
    });
  }

  /* ---- Produktgalleri ----
     Billederne ligger side om side i et spor med scroll-snap. Rulningen
     er browserens egen, så et stryg på en telefon virker uden en linje
     JavaScript — pilene og miniaturerne flytter bare det samme spor.
     Uden JavaScript kan man stadig rulle sporet med fingeren. */
  function galleriIGang(rodElement) {
    (rodElement || document).querySelectorAll("[data-sam-galleri]").forEach(function (galleri) {
      if (galleri.dataset.samKlar) return;
      galleri.dataset.samKlar = "1";

      var spor = galleri.querySelector("[data-sam-galleri-spor]");
      if (!spor) return;

      var dias = Array.prototype.slice.call(galleri.querySelectorAll("[data-sam-galleri-dias]"));
      var smaa = Array.prototype.slice.call(galleri.querySelectorAll("[data-sam-galleri-vaelg]"));
      var pile = Array.prototype.slice.call(galleri.querySelectorAll("[data-sam-galleri-pil]"));
      if (dias.length < 2) return;

      var aktiv = 0;

      function rulTil(nr) {
        var mal = dias[Math.max(0, Math.min(dias.length - 1, nr))];
        if (!mal) return;
        spor.scrollTo({ left: mal.offsetLeft - spor.offsetLeft, behavior: "smooth" });
      }

      function markér(nr) {
        aktiv = nr;
        smaa.forEach(function (knap, i) {
          knap.setAttribute("aria-current", i === nr ? "true" : "false");
        });
        /* En pil, der ikke kan gøre noget, skal se ud, som om den ikke kan. */
        pile.forEach(function (pil) {
          var retning = Number(pil.dataset.samGalleriPil);
          var slut = retning < 0 ? nr === 0 : nr === dias.length - 1;
          pil.disabled = slut;
        });
      }

      smaa.forEach(function (knap, i) {
        knap.addEventListener("click", function () {
          rulTil(i);
          markér(i);
        });
      });

      pile.forEach(function (pil) {
        pil.addEventListener("click", function () {
          var nr = aktiv + Number(pil.dataset.samGalleriPil);
          rulTil(nr);
          markér(Math.max(0, Math.min(dias.length - 1, nr)));
        });
      });

      /* Stryger man selv, skal miniaturerne følge med. Observeren tæller
         det billede, der fylder mest af sporet, som det viste. */
      if ("IntersectionObserver" in window) {
        var kig = new IntersectionObserver(
          function (poster) {
            poster.forEach(function (post) {
              if (post.intersectionRatio > 0.6) {
                markér(dias.indexOf(post.target));
              }
            });
          },
          { root: spor, threshold: [0.61] }
        );
        dias.forEach(function (d) {
          kig.observe(d);
        });
      }

      markér(0);
    });
  }

  /* ---- Foldere (produktdetaljer, FAQ) ---- */
  function folderIGang(rodElement) {
    (rodElement || document).querySelectorAll(".folder__knap, .segment__knap").forEach(function (knap) {
      if (knap.dataset.samKlar) return;
      knap.dataset.samKlar = "1";

      knap.addEventListener("click", function () {
        var aaben = knap.getAttribute("aria-expanded") === "true";
        var gruppe = knap.closest("[data-sam-folder-gruppe]");
        // Én ad gangen, når folderne står i en gruppe
        if (gruppe && !aaben) {
          gruppe
            .querySelectorAll('.folder__knap[aria-expanded="true"], .segment__knap[aria-expanded="true"]')
            .forEach(function (a) {
              a.setAttribute("aria-expanded", "false");
            });
        }
        knap.setAttribute("aria-expanded", aaben ? "false" : "true");
      });
    });
  }

  /* ---- Læs mere (historiesektionen på mobil) ----
     Knappen er skjult, indtil den er sat op her. Sker der noget med
     JavaScript, står teksten altså fuldt læselig i stedet for at være
     klippet af uden en vej ud. */
  function mereIGang(rodElement) {
    (rodElement || document).querySelectorAll("[data-sam-mere]").forEach(function (knap) {
      if (knap.dataset.samKlar) return;

      var brod = document.getElementById(knap.getAttribute("aria-controls"));
      if (!brod) return;

      knap.dataset.samKlar = "1";
      brod.setAttribute("data-sam-foldet", "true");

      knap.addEventListener("click", function () {
        var foldet = brod.getAttribute("data-sam-foldet") === "true";
        brod.setAttribute("data-sam-foldet", foldet ? "false" : "true");
        knap.setAttribute("aria-expanded", foldet ? "true" : "false");
      });
    });
  }

  /* ---- Slider med pile (anmeldelser på desktop) ----
     Sporet er et almindeligt scroll-felt med snap. Pilene ruller det
     ét kort ad gangen. Uden JavaScript kan sporet stadig rulles med
     mus, touch og piletaster — pilene er en genvej, ikke adgangsvejen. */
  function sliderIGang(rodElement) {
    (rodElement || document).querySelectorAll("[data-sam-slider-spor]").forEach(function (spor) {
      if (spor.dataset.samKlar) return;

      var aeske = spor.closest(".sam-slider");
      var knapper = aeske ? aeske.querySelectorAll("[data-sam-slider]") : [];
      if (!knapper.length) return;

      spor.dataset.samKlar = "1";

      var opdater = function () {
        // 2 px slør, fordi delpixels ellers kan holde knappen levende
        var slut = spor.scrollWidth - spor.clientWidth - 2;
        knapper.forEach(function (knap) {
          var frem = Number(knap.dataset.samSlider) > 0;
          knap.disabled = frem ? spor.scrollLeft >= slut : spor.scrollLeft <= 2;
        });
      };

      knapper.forEach(function (knap) {
        knap.addEventListener("click", function () {
          var kort = spor.firstElementChild;
          var mellemrum = parseFloat(getComputedStyle(spor).columnGap) || 0;
          var skridt = kort
            ? kort.getBoundingClientRect().width + mellemrum
            : spor.clientWidth * 0.8;
          spor.scrollBy({ left: skridt * Number(knap.dataset.samSlider), behavior: "smooth" });
        });
      });

      spor.addEventListener("scroll", opdater, { passive: true });
      window.addEventListener("resize", opdater, { passive: true });
      opdater();
    });
  }

  /* ---- Antalsvælger ---- */
  function antalIGang(rodElement) {
    (rodElement || document).querySelectorAll(".antal").forEach(function (boks) {
      if (boks.dataset.samKlar) return;
      boks.dataset.samKlar = "1";

      var felt = boks.querySelector("input");
      if (!felt) return;

      boks.querySelectorAll("button").forEach(function (knap) {
        knap.addEventListener("click", function () {
          var v = parseInt(felt.value, 10) || 1;
          v += knap.dataset.samTrin === "op" ? 1 : -1;
          var mindst = parseInt(felt.min, 10) || 1;
          var mest = parseInt(felt.max, 10) || 99;
          felt.value = Math.max(mindst, Math.min(mest, v));
          felt.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });
  }

  /* ---- Filtre uden sideskift ----
     Kategori- og emneknapperne er rigtige links til kollektioner og
     tag-URL'er, så de kan deles, bogmærkes og findes af Google. Her fanger
     vi klikket, henter den samme side og skifter kun resultatlisten ud.
     Fejler noget som helst, følger vi linket som normalt. */
  var samHarSkiftet = false;

  function hentOgUdskift(url, noegle, tilHistorik) {
    var maal = document.querySelector('[data-sam-udskift="' + noegle + '"]');
    if (!maal) {
      window.location.href = url;
      return;
    }

    maal.setAttribute("aria-busy", "true");

    fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (svar) {
        if (!svar.ok) throw new Error(svar.status);
        return svar.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var nytIndhold = doc.querySelector('[data-sam-udskift="' + noegle + '"]');
        if (!nytIndhold) throw new Error("intet indhold");

        maal.innerHTML = nytIndhold.innerHTML;

        // Knapperne skal med, ellers står den gamle markeret som valgt
        var nav = document.querySelector('[data-sam-filtre="' + noegle + '"]');
        var nytNav = doc.querySelector('[data-sam-filtre="' + noegle + '"]');
        if (nav && nytNav) nav.innerHTML = nytNav.innerHTML;

        if (doc.title) document.title = doc.title;

        if (tilHistorik) {
          if (!samHarSkiftet) {
            history.replaceState({ sam: noegle }, "", window.location.href);
            samHarSkiftet = true;
          }
          history.pushState({ sam: noegle }, "", url);
        }

        maal.removeAttribute("aria-busy");
        saetIGang(maal);
        folderIGang(maal);
        antalIGang(maal);
        mereIGang(maal);
        sliderIGang(maal);

        // Rul kun op, hvis listen er røget op over skærmkanten
        var hoved = parseInt(
          getComputedStyle(document.documentElement).getPropertyValue("--header-height"),
          10
        );
        var top = maal.getBoundingClientRect().top + window.scrollY - (hoved || 0) - 24;
        if (window.scrollY > top) window.scrollTo({ top: top, behavior: "smooth" });
      })
      .catch(function () {
        window.location.href = url;
      });
  }

  // Én lytter på dokumentet, så den også gælder knapper, vi selv har indsat.
  // Den kører i indfangningsfasen: temaets egen sideovergang lytter også på
  // klik på links, og når begge lytter i boblefasen, når den først. Så skifter
  // siden alligevel, selvom kategorien skulle udskiftes på stedet.
  document.addEventListener("click", function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
      return;
    }
    var link = e.target.closest ? e.target.closest("[data-sam-filtre] a[href]") : null;
    if (!link || link.target === "_blank") return;
    if (link.origin !== window.location.origin) return;

    var nav = link.closest("[data-sam-filtre]");
    if (!nav || !nav.dataset.samFiltre) return;

    // Stop også de øvrige lyttere, ellers navigerer temaet oveni
    e.preventDefault();
    e.stopPropagation();
    hentOgUdskift(link.href, nav.dataset.samFiltre, true);
  }, true);

  window.addEventListener("popstate", function (e) {
    if (!samHarSkiftet) return;
    if (e.state && e.state.sam) {
      hentOgUdskift(window.location.href, e.state.sam, false);
    } else {
      window.location.reload();
    }
  });

  headerIGang();
  mobilmenuIGang();
  galleriIGang(document);
  folderIGang(document);
  antalIGang(document);
  mereIGang(document);
  sliderIGang(document);

  /* Temaeditoren genindlæser én sektion ad gangen — så skal den nye
     sektions elementer også have deres observer. */
  document.addEventListener("shopify:section:load", function (e) {
    saetIGang(e.target);
    headerIGang();
    mobilmenuIGang();
    galleriIGang(e.target);
    folderIGang(e.target);
    antalIGang(e.target);
    mereIGang(e.target);
    sliderIGang(e.target);
  });
})();
